import { render, staticRenderFns } from "./ManageCustomersImport.vue?vue&type=template&id=494c041a&scoped=true"
import script from "./ManageCustomersImport.vue?vue&type=script&lang=js"
export * from "./ManageCustomersImport.vue?vue&type=script&lang=js"
import style0 from "./ManageCustomersImport.vue?vue&type=style&index=0&id=494c041a&prod&scoped=true&lang=css"
import style1 from "./ManageCustomersImport.vue?vue&type=style&index=1&id=494c041a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494c041a",
  null
  
)

export default component.exports